import { fromJS } from 'immutable';

export default fromJS({
    members: [],
    facility: null,
    membersTotalCount: 0,
    selectedMembers: [],
    memberToDeactivate: undefined,
});
